<template>
  <Card class="mt-3">
    <template #title>Run-Rate</template>
    <template #content>
      <div class="table-responsive">
        <table class="md-table">
          <thead>
            <tr>
              <th>Metric</th>
              <th>Planned</th>
              <th>Run Rate</th>
              <th v-if="hasEditableRows">Actions</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="loading">
              <tr v-for="index in placeholderRows" :key="`runrate-${index}`">
                <td><Skeleton height="1.4rem" /></td>
                <td><Skeleton height="1.4rem" /></td>
                <td><Skeleton height="1.4rem" /></td>
                <td v-if="hasEditableRows"><Skeleton height="1.4rem" /></td>
              </tr>
            </template>
            <template v-else>
              <tr v-for="row in rows" :key="row.key || row.label">
                <td>{{ row.label }}</td>
                <td>{{ row.planned }}</td>
                <td class="font-semibold text-blue-600">{{ row.rate }}</td>
                <td v-if="hasEditableRows">
                  <Button
                    icon="pi pi-pencil"
                    size="small"
                    v-tooltip.bottom="'Edit planned value'"
                    aria-label="Edit planned value"
                    outlined
                    v-if="row.canEdit"
                    @click="emit('edit', row)"
                  />
                </td>
              </tr>
              <tr v-if="!rows.length">
                <td :colspan="hasEditableRows ? 4 : 3" class="md-empty">
                  Run-rate not available.
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </template>
  </Card>
</template>

<script setup>
import { defineEmits, defineProps, computed } from "vue";
import Card from "primevue/card";
import Skeleton from "primevue/skeleton";
import Button from "primevue/button";

const emit = defineEmits(["edit"]);

const props = defineProps({
  rows: {
    type: Array,
    default: () => [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
  editable: {
    type: Boolean,
    default: false,
  },
});

const placeholderRows = 3;

const hasEditableRows = computed(
  () => props.editable && props.rows.some((row) => row?.canEdit)
);
</script>

<style scoped>
.table-responsive {
  overflow-x: auto;
}

.md-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.md-table thead {
  background: var(--surface-100);
}

.md-table th,
.md-table td {
  padding: 0.75rem;
  border-bottom: 1px solid var(--surface-border);
  text-align: left;
}

.md-empty {
  border: 1px dashed var(--surface-border);
  border-radius: 12px;
  padding: 1.25rem;
  text-align: center;
  font-size: 0.9rem;
  color: var(--text-color-secondary);
  background: var(--surface-ground);
}
</style>
